import { COA_SET, COA_EDITED, COA_ADDED, COA_DELETED } from 'src/app/redux/redux-types';
import { reduxCoaTypes } from 'src/types';

export const coaDefaultState: reduxCoaTypes.StateType = {
  coaList: [],
};

export const coaReducer = (state = coaDefaultState, action: reduxCoaTypes.ActionType): reduxCoaTypes.StateType => {
  switch (action.type) {
    case COA_SET:
      return {
        ...state,
        coaList: action.payload,
      };
    case COA_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.coaList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        coaList: [action.payload, ...state.coaList],
      };
    case COA_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.coaList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        coaList: [...state.coaList.slice(0, updateIndex), action.payload, ...state.coaList.slice(updateIndex + 1)],
      };
    case COA_DELETED:
      return {
        ...state,
        coaList: state.coaList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
